import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Behfa_Interface, Empty_Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { HelpService } from 'src/app/Service/Help/Help.service';
import { environment } from 'src/environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-HelpForm',
  templateUrl: './HelpForm.component.html',
  styleUrls: ['./HelpForm.component.scss']
})
export class HelpFormComponent implements OnInit {

  @Input() inner_Nav:Nav_Interface=Empty_Nav_Interface()
  @Output() OnBack_Help_Action = new EventEmitter<number>();
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false
  BaseUrl=environment.BaseUrl

  selected_Record_Help:Behfa_Interface=Empty_Behfa_Interface()

  Form_Swicher_Name:string="List"

  set_Form_Swicher_Name(item:string)
  {
    this.Form_Swicher_Name=item
  }





  modalRef_Delete: any;

  constructor(
    private Help_Service:HelpService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService
  ) { }


  DataList_Help:Array<Behfa_Interface>=[]
  Data_Seleted_Delete:Behfa_Interface=Empty_Behfa_Interface()

  ngOnInit() {
    this.ReadData_Help()

  }

  ReadData_Help(){
    this.Procssing=true
    this.Help_Service.GetRecord(this.inner_Nav.id).subscribe(
      data=>{
        this.DataList_Help=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Behfa_Interface){
    item.deletingProccess=true
    this.modalRef_Delete.hide()
    this.Help_Service.DeleteHelp(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Help()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Priority(item:Behfa_Interface){
    item.deletingProccess=true
    this.Help_Service.PriorityHelp(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

        this.ReadData_Help()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  //#region TEXT

  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>متن خود را اینجا تایپ کنید ...</p>'
  };
  public config = {
    language: 'fa'
  };

  set_Form_Swicher_Name_For_Text_Edit(item:Behfa_Interface){
    this.Form_Swicher_Name='Text'
    this.selected_Record_Help=item
    this.model.editorData=item.val
  }

  set_Form_Swicher_Name_For_Text(){
    this.Form_Swicher_Name='Text'
    this.selected_Record_Help=Empty_Behfa_Interface()
  }


  onSubmitText(){
    this.Procssing=true
    this.selected_Record_Help.type=1
    this.selected_Record_Help.val=this.model.editorData
    this.Help_Service.AddEditHelp(this.selected_Record_Help,this.inner_Nav.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.selected_Record_Help=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion


  //#region Image


  InProccessing_image:boolean=false
  uploadimage(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_image=true

    this.Help_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.selected_Record_Help.val=data['filename']
        }
      }
    )
  }

  Remove_uploadimage(){
    this.selected_Record_Help.val=''
  }

  modalRef_Image: any;
  ModalimageUrl:String=''
  openModalImage(template: TemplateRef<any>,imageUrl:String) {
    this.ModalimageUrl=imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  onSubmitImage(){

    if(!this.selected_Record_Help.val)
    {
      this.Alertify_Service.ErrorMessage("عکس مورد نظر را انتخاب نمائید")
    }
    else{
      this.Procssing=true
      this.selected_Record_Help.type=2
      this.Help_Service.AddEditHelp(this.selected_Record_Help,this.inner_Nav.id).subscribe(
        data=>{
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.selected_Record_Help=data
          this.Procssing=false
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }

  set_Form_Swicher_Name_For_Image_Edit(item:Behfa_Interface){
    this.Form_Swicher_Name='Image'
    this.selected_Record_Help=item
    this.model.editorData=item.val
  }


  set_Form_Swicher_Name_For_Image(){
    this.Form_Swicher_Name='Image'
    this.selected_Record_Help=Empty_Behfa_Interface()
  }


  //#endregion

  //#region Video


  InProccessing_Video:boolean=false
  uploadVideo(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Video=true

    this.Help_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_Video=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.selected_Record_Help.val=data['filename']
        }
      }
    )
  }

  Remove_uploadVideo(){
    this.selected_Record_Help.val=''
  }


  onSubmitVideo(){

    if(!this.selected_Record_Help.val)
    {
      this.Alertify_Service.ErrorMessage("عکس مورد نظر را انتخاب نمائید")
    }
    else{
      this.Procssing=true
      this.selected_Record_Help.type=3
      this.Help_Service.AddEditHelp(this.selected_Record_Help,this.inner_Nav.id).subscribe(
        data=>{
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.selected_Record_Help=data
          this.Procssing=false
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }

  set_Form_Swicher_Name_For_Video_Edit(item:Behfa_Interface){
    this.Form_Swicher_Name='Video'
    this.selected_Record_Help=item
    this.model.editorData=item.val
  }


  set_Form_Swicher_Name_For_Video(){
    this.Form_Swicher_Name='Video'
    this.selected_Record_Help=Empty_Behfa_Interface()
  }


  //#endregion



  OnSet_Back_HelpList(){
    this.OnBack_Help_Action.emit(-1);
  }

}
